/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class ReportsAPI extends ApiClient {
  constructor() {
    super('reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getReports({
    metric,
    from,
    to,
    type = 'account',
    id,
    groupBy,
    businessHours,
    agentIds,
    inboxIds,
  }) {
    return axios.get(`${this.url}`, {
      params: {
        metric,
        since: from,
        until: to,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        agent_ids: agentIds,
        inbox_ids: inboxIds,
      },
    });
  }

  // eslint-disable-next-line default-param-last
  getSummary(since, until, type = 'account', id, groupBy, businessHours, agentIds, inboxIds) {
    return axios.get(`${this.url}/summary`, {
      params: {
        since,
        until,
        type,
        id,
        group_by: groupBy,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        agent_ids: agentIds,
        inbox_ids: inboxIds,
      },
    });
  }

  getConversationMetric(type = 'account', page = 1, agentIds, inboxIds) {
    return axios.get(`${this.url}/conversations`, {
      params: {
        type,
        page,
        agent_ids: agentIds,
        inbox_ids: inboxIds,
      },
    });
  }

  getAgentReports({ from: since, to: until, businessHours, userIds, inboxIds }) {
    return axios.get(`${this.url}/agents`, {
      params: { 
        since, 
        until, 
        business_hours: businessHours,
        user_ids: userIds,
        inbox_ids: inboxIds
      },
    });
  }

  getConversationTrafficCSV() {
    return axios.get(`${this.url}/conversation_traffic`, {
      params: { timezone_offset: getTimeOffset() },
    });
  }

  getLabelReports({ from: since, to: until, businessHours, labelIds }) {
    return axios.get(`${this.url}/labels`, {
      params: { 
        since, 
        until, 
        business_hours: businessHours,
        label_ids: labelIds 
      },
    });
  }
  
  getInboxReports({ from: since, to: until, businessHours, inboxIds, agentIds }) {
    return axios.get(`${this.url}/inboxes`, {
      params: { 
        since, 
        until, 
        business_hours: businessHours,
        inbox_ids: inboxIds,
        agent_ids: agentIds
      },
    });
  }
  
  getTeamReports({ from: since, to: until, businessHours, teamIds }) {
    return axios.get(`${this.url}/teams`, {
      params: { 
        since, 
        until, 
        business_hours: businessHours,
        team_ids: teamIds 
      },
    });
  }

  getCustomAttributeReports({ from: since, to: until, businessHours, customAttributeIds }) {
    return axios.get(`${this.url}/custom_attributes`, {
      params: { 
        since, 
        until, 
        business_hours: businessHours,
        custom_attribute_ids: customAttributeIds 
      },
    });
  }  

  getBotMetrics({ from, to } = {}) {
    return axios.get(`${this.url}/bot_metrics`, {
      params: { since: from, until: to },
    });
  }

  getBotSummary({ from, to, groupBy, businessHours } = {}) {
    return axios.get(`${this.url}/bot_summary`, {
      params: {
        since: from,
        until: to,
        type: 'account',
        group_by: groupBy,
        business_hours: businessHours,
      },
    });
  }
}

export default new ReportsAPI();
